import { render, staticRenderFns } from "./Archivos.vue?vue&type=template&id=2d9e0469&"
import script from "./Archivos.vue?vue&type=script&lang=js&"
export * from "./Archivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports